'use client';

import { createContext, useState } from 'react';

export const DestinationFilter = createContext(null);

export function DestinationFilterProvider({ children }) {
  const [categoryFilters, setCategoryFilters] = useState([]);

  return (
    <DestinationFilter.Provider value={{ categoryFilters, setCategoryFilters }}>{children}</DestinationFilter.Provider>
  );
}
